export function hasChangedSpecificProps(currentProps, prevProps, propsToCompare) {
    for(let propName of propsToCompare) {
        if (currentProps[propName] !== prevProps[propName]) {
            return true;
        }
    }
    return false;
}